<template>
  <div>
    <!--    <div style="text-align:left;color:#333;width:1280px;padding:0 90px;">-->
    <!--      个人中心-->
    <!--    </div>-->
    <div class="tit">收款信息</div>
    <el-form
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      style="padding:0 170px 30px 170px;width:800px;margin:auto;"
      :model="ruleForm"
      :rules="rules"
    >
      <el-form-item label="单位名称：" class="cell">
        <el-input
          v-model="user.userName"
          style="width:288px;"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item class="cell" label="开户银行：" prop="invoiceOpenBank">
        <el-input
          v-model="ruleForm.invoiceOpenBank"
          style="width:288px;"
        ></el-input>
      </el-form-item>
      <el-form-item class="cell" label="银行账号：" prop="invoiceBankNo">
        <el-input
          v-model="ruleForm.invoiceBankNo"
          style="width:288px;"
        ></el-input>
      </el-form-item>
      <el-form-item
        class="cell"
        label="联系电话："
        prop="phone"
        style="color:#red;"
      >
        <el-input v-model="ruleForm.phone" style="width:288px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :loading="btLoading"
        >
          保存
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<style lang="scss" scoped>
.tit {
  text-align: left;
  width: 1280px;
  padding: 0 90px;
  // margin: 0 auto;
  margin-top: 45px;
  color: #2e2f2f;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  align-items: center;
  line-height: 24px;
  margin-bottom: 30px;
}
.tit::before {
  content: '';
  width: 8px;
  height: 24px;
  background: #1989fa;
  display: block;
  margin-right: 8px;
}
.cell {
  width: 320px;
}
</style>

<script>
import { btLoading } from '@/Mixin/btLoading';
import { makeSure } from '@/Mixin/makeSure';
import { mapMutations } from 'vuex';
import { getStorage } from '@/tools/storage';
import { csoUserKz } from '@/api/ajax';
export default {
  mixins: [btLoading, makeSure],
  data() {
    return {
      user: getStorage('user'),
      ruleForm: {
        phone: '',
        invoiceOpenBank: '',
        invoiceBankNo: ''
      },
      rules: {
        invoiceOpenBank: [
          {
            required: true,
            message: '开户银行不能为空',
            trigger: 'blur'
          }
        ],
        invoiceBankNo: [
          {
            required: true,
            message: '银行卡号不能为空',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            message: '联系电话不能为空',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    ...mapMutations(['INIT_PROJECT_STATE']),
    formatBankNumber(bankNumber) {
      if (bankNumber.length < 8) {
        return bankNumber.substr(0, 4) + '********' + bankNumber.substr(-4);
      } else {
        return bankNumber;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let cbEvent = () => {
            csoUserKz.addUpdateCsoUserKzDetail(this.ruleForm).then(() => {
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success'
              });
              this.$router.push({ name: 'home' });
            });
          };
          if (this.priceFlag == false) {
            this.makeSureEvent(cbEvent);
          } else {
            cbEvent();
          }
        } else {
          return false;
        }
      });
    }
  },
  created() {
    this.INIT_PROJECT_STATE();
    // this.bankNo = this.formatBankNumber(this.otherInfo.invoiceBankNo)
    csoUserKz.csoUserKzDetail().then(res => {
      this.ruleForm = res.data.data;
    });
  }
};
</script>
